import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";
import LeadForm from "./LeadForm";
import Reveal, { Eyebrow } from "./Reveal";

export default function FinalCta() {
  return (
    <section id="final-cta" className="scroll-mt-16 py-24 sm:py-32" data-testid="final-cta-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#C05746] text-white px-6 py-16 sm:px-14 sm:py-20 grain grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <Eyebrow className="!text-white/70">Inizia oggi</Eyebrow>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1] mt-4">
              Il tuo primo giorno inizia con un'email.
            </h2>
            <p className="mt-6 text-white/80 max-w-md">
              Preferisci parlarne direttamente? Ogni settimana tengo alcune chiamate conoscitive gratuite da 20 minuti.
            </p>
            <Link
              to="/prenota"
              data-testid="final-cta-book-call-link"
              className="mt-6 inline-flex items-center gap-2 font-semibold link-underline"
            >
              <CalendarHeart className="w-4 h-4" /> Prenota una chiamata gratuita
            </Link>
          </Reveal>
          <Reveal delay={0.15} className="lg:justify-self-end w-full max-w-md">
            <div className="bg-[#1E231F]/25 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/15">
              <LeadForm id="final-lead" source="final_cta" dark />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
